// extracted by mini-css-extract-plugin
module.exports = {"header":"thpZH","logo":"bmH6+","footerButton":"_1-cPw"};